// Las 13 secciones de la Carpeta AFAC concentradora (CO-SA-17.18/24)
// y las 7 fases del ciclo. Las marcadas con `noJMA: true` son las
// secciones cuyos documentos los entregan terceros (UVA / autoridad),
// no JMA: su semáforo se interpreta distinto en client-aggregator.

export const AFAC_SECCIONES = [
  { numero: 1, nombre: 'Plan de Trabajo' },
  { numero: 2, nombre: 'Inventarios' },
  { numero: 3, nombre: 'Diagnóstico Brechas' },
  { numero: 4, nombre: 'Pentest Diagnóstico' },
  { numero: 5, nombre: 'Plan Remediación' },
  { numero: 6, nombre: 'Evidencias Remediación' },
  { numero: 7, nombre: 'Pentest Confirmación' },
  { numero: 8, nombre: 'Constancia Implementación' },
  { numero: 9, nombre: 'Verificación UVA', noJMA: true },
  { numero: 10, nombre: 'Informe Semestral' },
  { numero: 11, nombre: 'Bitácora Incidentes' },
  { numero: 12, nombre: 'Acuses Regulatorios', noJMA: true },
  { numero: 13, nombre: 'Mejora Continua' }
]

export const FASES = [
  { numero: 0, nombre: 'Levantamiento preliminar' },
  { numero: 1, nombre: 'Diagnóstico y pentest' },
  { numero: 2, nombre: 'Análisis y propuesta' },
  { numero: 3, nombre: 'Ejecución de remediaciones' },
  { numero: 4, nombre: 'Pentest de confirmación' },
  { numero: 5, nombre: 'Verificación UVA y entrega' },
  { numero: 6, nombre: 'Continuidad semestral' }
]
